<template>
  <div class="master-bank-page master-bank-page--edit">

    <section class="master-bank-page__header">
      <div class="master-bank-page__header-icon">
        <i class="fas fa-pen" aria-hidden="true"></i>
      </div>
      <div>
        <span>MASTER PEMBAYARAN</span>
        <h1>Edit bank</h1>
        <p>Perbarui nama dan deskripsi bank yang digunakan pada transaksi.</p>
      </div>
    </section>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card class="master-bank-page__card" v-bind:title="'Informasi bank'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              :route="'banks/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/banks/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: "",
        description: "",
      },
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('banks/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/masters/banks/list')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bank", route: "" },
      { title: "Daftar Bank", route: "/masters/banks/list" },
      { title: "Edit" },
    ])
    // Get Data
    this.get()
  },

}

</script>
